import { TICKET_SUMMARY_QUERY_CONTEXT_PREFIX } from './constants';

export function makeTicketSummaryQueryContextKey(orderId: string) {
  return `${TICKET_SUMMARY_QUERY_CONTEXT_PREFIX}_${orderId}_ticket_summary`;
}
